/* RESPONSIBLE TEAM: team-fin-nux */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { schedule } from '@ember/runloop';
import { ReactRoute } from 'embercom/lib/react-route';
import type AppService from 'embercom/services/app-service';

class FinStudioRoute extends Route {
  @service declare appService: AppService;

  private get isFullPageMessengerEnabled(): boolean {
    return this.appService.app.canUseFinSuccessAgentExperimentFinStudio;
  }

  reactEnabled() {
    return !this.isFullPageMessengerEnabled;
  }

  activate() {
    if (this.isFullPageMessengerEnabled) {
      schedule('afterRender', () => {
        let url = new URL(window.location.href);
        url.searchParams.set('fin_success_experiment', 'true');
        window.history.replaceState(null, '', url.toString());

        window.Intercom?.('update', { fin_studio_session: Date.now() });
        window.Intercom?.('startFullPageMessenger', '#fin-studio-messenger-container');

        requestAnimationFrame(() => {
          if (!window.location.search.includes('fin_success_experiment=true')) {
            let refreshUrl = new URL(window.location.href);
            refreshUrl.searchParams.set('fin_success_experiment', 'true');
            window.history.replaceState(null, '', refreshUrl.toString());
          }
        });
      });
    }
  }

  deactivate() {
    if (this.isFullPageMessengerEnabled) {
      window.Intercom?.('stopFullPageMessenger');
    }
  }
}

export default ReactRoute(FinStudioRoute);
